import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { HaloToastService, EToastType } from 'src/app/core/halo-toast/halo-toast.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { VideoInfoRaw, VideoLibraryExt } from './video-library.model';
import { VideoLibraryService } from './video-library.service';
import { environment } from 'src/environments/environment';
import { HaloTipsService } from 'src/app/core/halo-tips/halo-tips.service';
import { HaloModalSize, HaloModalService } from 'src/app/core/halo-modal/halo-modal';
import { MultiFacilityService } from '../services/multi-facility.service';
import { MultiFacilityModel } from '../services/multi-facility.model';
import { ViewVideoCompatibilityModel } from '../services/multi-console.model';
import { HaloCustomLoaderErrorType } from 'src/app/core/halo-custom-loader/halo-custom-loader.service';
import { SelectionInfo } from '../selectors/multi-selection/multi-selection.model';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';

@Component({
  selector: 'app-video-library',
  templateUrl: './video-library.component.html',
  styleUrls: ['./video-library.component.scss'],
})
export class VideoLibraryComponent implements OnInit, OnDestroy, AfterViewInit {
  rootScopeData: RootScopeDeclare;
  equipmentList = [] as any;
  isConsoleCountExist = false;
  videoLibraryList: VideoLibraryExt;
  selectedVideo: VideoInfoRaw;
  multiFacilities: MultiFacilityModel[];
  multiFacilitiesForPublish: MultiFacilityModel[];
  viewVideoCompatibility: ViewVideoCompatibilityModel[];
  selectedFacilities: any[];
  currentFacility: FacilityObject;
  selectedCount: number;
  selectedVideoCount: number;
  currentUrl: string;
  customVideoStatus: string;
  buttonGroup: string[];
  publishCustomVideoSteps = [
    { stepNumber: 1, stepText: 'Select Facilities' },
    { stepNumber: 2, stepText: 'View Video Compatibility' },
  ];
  displayStep = 1;
  sub = new Subscription();
  customLoaderIsLoading = false; //customLoaderIsLoading for customSpinner.
  customLoaderErrorMsg: string;
  sortingInfo: { columnName: string; isAscOrder: boolean } = { columnName: 'status', isAscOrder: false };
  paginationInfo: { currentPage: number; rowsPerPage: number } = { currentPage: 1, rowsPerPage: 10 };
  showActionBar = false;
  hasFullPermission = false;
  selectionInfo: SelectionInfo;
  actionVideoLibraryError = [] as any;
  actionVideoLibraryErrorForAllVideo = [] as any;
  actionVideoLibraryErrorForFacilities = [] as any;
  actionVideoLibraryErrorTitle: string;
  actionVideoLibraryErrorMessage: string;
  disableSelectAll = false;
  enabledEquipmentOnDemandNCustomLibrary = [] as any;
  showUploadDisable = false;
  showUploadDisableProperties = {
    title: 'CUSTOM.LIBRARY.DISABLE.UPLOAD.TITLE',
    message: 'CUSTOM.LIBRARY.DISABLE.UPLOAD.MESSAGE',
    isWarningPopup: true,
    ctaButtonLabel: 'OK',
    isSecondaryTextButton: true,
  };

  selectedStrapiIdMaxIdList = [] as any;
  selectedUploadedVideoList = [] as VideoInfoRaw[];
  frameRateList = [] as any;
  facilitiesConsoleEquipmentsMap: any;
  cloudBasePath = environment.cloudBasePath;
  zendeskUrl: string;
  isEnabledUnpublishButton = false;
  // Below is Viewchild Template for custom video.
  @ViewChild('titleTemplateForCustomVideo') titleTemplateForCustomVideo: TemplateRef<any>;
  @ViewChild('actionForCustomVideo') actionForCustomVideo: TemplateRef<any>;
  @ViewChild('facilitiesTemplateForPublishCustomVideo') facilitiesTemplateForPublishCustomVideo: TemplateRef<any>;
  @ViewChild('facilitiesTemplateForCustomVideo') facilitiesTemplateForCustomVideo: TemplateRef<any>;
  @ViewChild('facilitiesTemplateForDeleteCustomVideo') facilitiesTemplateForDeleteCustomVideo: TemplateRef<any>;
  @ViewChild('workoutPreviewTemplate') workoutPreviewTemplate: TemplateRef<any>;

  @ViewChild('actionErrorTitleTemplate') actionErrorTitleTemplate: TemplateRef<any>;
  @ViewChild('actionErrorBodyTemplate') actionErrorBodyTemplate: TemplateRef<any>;
  @ViewChild('actionErrorBodyTemplateForPublishCustomVideo')
  actionErrorBodyTemplateForPublishCustomVideo: TemplateRef<any>;
  @ViewChild('actionErrorActionTemplate') actionErrorActionTemplate: TemplateRef<any>;
  constructor(
    private _rootScopeService: RootScopeService,
    private _facilityService: FacilityService,
    private _modal: HaloModalService,
    private _toast: HaloToastService,
    private _vdoLibraryService: VideoLibraryService,
    private _router: Router,
    private _multiFacilityService: MultiFacilityService,
    private haloTips: HaloTipsService,
    private commonUtil: CommonUtil,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _commonUtil: CommonUtil,
    private _loader: HaloLoaderService
  ) {
    const routerSub = this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (this._multiFacilityService.isMultifacilityUrl(event.url)) {
          this.currentUrl = event.url;
        }
      }
    });
    this.sub.add(routerSub);
  }

  prepareEquipmentList(val: any) {
    const tmp_2 = Object.values(val)[0] as any;
    if (JSON.stringify(tmp_2) === '{}') {
      return [];
    } else {
      return Object.values(tmp_2).map((ele: any) => {
        return {
          count: ele.customLibraryEnabledCount,
          consoleType: ele.consoleType,
          orderId: ele.orderId,
          consoleName: this.getConsoleName(ele.consoleType),
        };
      });
    }
  }

  async ngOnInit() {
    this.zendeskUrl = 'https://lifefitness9512.zendesk.com/hc/en-us/articles/6916317796887';
    this.currentFacility = this._facilityService.selectedFacility();
    const uploadVideoListSub = this._vdoLibraryService.uploadingVideoListSubscriber.subscribe(async (data) => {
      setTimeout(async () => {
        this.customLoaderIsLoading = true;
        try {
          await this.loadVideoLibraryList();
          this.customLoaderIsLoading = false;
        } catch (error) {
          console.error('API failed.');
        }
      }, 7000);
    });
    this.sub.add(uploadVideoListSub);

    const facilityChanges = this._facilityService.selectedFacilitySource.subscribe(async (val) => {
      this.currentFacility = val;
      this.haloTips.onDismissed();
      await this.prepareView();
    });

    const lfAssetApiResp = await this._facilityService.get();
    if (lfAssetApiResp) {
      this.facilitiesConsoleEquipmentsMap = lfAssetApiResp.facilities;
    }

    this.sub.add(facilityChanges);
    this.prepareView();
    this.rootScopeData = this._commonUtil.rootScopeData;
  }

  private async prepareView() {
    if (!this.currentFacility?.summary) {
      return;
    }
    if (this.currentFacility.consoleEquipments) {
      this.customLoaderIsLoading = true;
      const isEligibleLFODFacilityRight = this.currentFacility.summary.facilityRights.customLibrary === 'true';
      const hasViewPermission = this.currentFacility.summary.userRights.customLibrary !== 'H';
      const isEligibleConsole = this._facilityService.isEligibleLFODPremiumConsole(this.currentFacility);
      if (!isEligibleConsole || !isEligibleLFODFacilityRight || !hasViewPermission) {
        this.commonUtil.redirectToAvailablePage();
      } else {
        try {
          const enabledOnDemandEquipmentList = await this.getEnabledOnDemandClasses();
          this.equipmentList = this.prepareEquipmentList(enabledOnDemandEquipmentList);
          this.isConsoleCountExist = this.equipmentList.find((val: any) => val.count !== 0) ? true : false;
          this.equipmentList = this.equipmentList.sort((a: any, b: any) => (a.orderId > b.orderId ? 1 : -1));
        } catch (ex) {
          this.equipmentList = [];
          this.isConsoleCountExist = false;
          console.log(ex);
        }

        try {
          await this.loadVideoLibraryList('1');
          this.customLoaderIsLoading = false;
        } catch (ex) {
          console.log(ex);
        }

        this.hasFullPermission =
          this.currentFacility.summary.userRights.customLibrary === 'F' ||
          this.currentFacility.summary.isLoggedInManagerAdmin === 'true';
      }
    } else {
      this.commonUtil.redirectToAvailablePage();
    }
  }

  timeout(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  getEnabledOnDemandClasses() {
    return this._vdoLibraryService
      .getEnabledOnDemandClasses([Number(this._facilityService.selectedFacilityId())])
      .toPromise();
  }

  async loadVideoLibraryList(defaultPage?: string) {
    this.setActionBar(false);
    this.customLoaderErrorMsg = '';
    try {
      this.videoLibraryList = await this._vdoLibraryService.getVideoLibraryList(
        this._facilityService.selectedFacilityId(),
        defaultPage ? defaultPage : this.paginationInfo.currentPage.toString(),
        this.paginationInfo.rowsPerPage.toString(),
        this.sortingInfo.columnName,
        this.sortingInfo.isAscOrder ? 'asc' : 'desc'
      );
      this.disableSelectAll = !this.videoLibraryList.videoList.some((val) => val.id);
      if (this.videoLibraryList?.videoList[0]?.statusCode === 1) setTimeout(() => this.showHaloTips());
    } catch (error) {
      this.customLoaderErrorMsg = HaloCustomLoaderErrorType.APIFAILED;
      throw error;
    }
  }

  onSelect(item: VideoInfoRaw) {
    if (item.statusCode < 2) return;
    item.attributes.isSelected = !item.attributes.isSelected;
    this.videoLibraryList.isAllSelected = this.videoLibraryList.videoList.every(
      (v) => (v.statusCode < 2 && !v.id) || v.attributes.isSelected
    );
    this.setActionBar(this.videoLibraryList.videoList.some((v) => v.attributes.isSelected));
    this.isEnabledUnpublishButton = !!this.videoLibraryList.videoList.filter(
      (v: any) => v.attributes.isSelected && (v.status == 'Published' || v.status == 'Edited')
    ).length;
  }

  onSelectAll() {
    this.videoLibraryList.isAllSelected = !this.videoLibraryList.isAllSelected;
    this.videoLibraryList.videoList.forEach((v) => {
      if (v.statusCode > 1 && !!v.id) v.attributes.isSelected = this.videoLibraryList.isAllSelected;
    });
    this.setActionBar(false);
    this.videoLibraryList.videoList.forEach((video) => {
      if (video.attributes.isSelected) {
        this.setActionBar(true);
      }
    });
    this.isEnabledUnpublishButton = !!this.videoLibraryList.videoList.filter(
      (v: any) => v.attributes.isSelected && (v.status == 'Published' || v.status == 'Edited')
    ).length;
  }

  ngAfterViewInit(): void {
    this.expandAccordianContent();
  }

  expandAccordianContent() {
    const tmp = $('#collapse2');
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    tmp.collapse('show');
    this.commonUtil.scrollTop();
  }

  enableWorkoutPreview(item: VideoInfoRaw) {
    this.selectedVideo = item;
    this._modal.add({
      dismissible: true,
      titleUppercase: true,
      modalSize: HaloModalSize.XLarge,
      onDismiss: this.onDismiss,
      bodyTemplate: this.workoutPreviewTemplate,
      isVideoTree: false,
      title: `${this.commonUtil.translateText('VIEW')} ${
        item.attributes.title ? item.attributes.title : item.attributes.muxAsset?.data?.attributes.title
      }`,
    });
  }

  getSelectedCount(facilities: MultiFacilityModel[]) {
    let count = 0;
    facilities?.forEach((facility) => {
      if (facility?.isSelected) {
        count++;
      }
      count += this.getSelectedCount(facility.children);
    });
    return count;
  }

  filter(facilities: MultiFacilityModel[]) {
    const filteredFacs: MultiFacilityModel[] = [];
    facilities?.forEach((facility) => {
      facility.children = this.filter(facility.children);
      facility.isEnabled = this.isValidLFODSupportFacility(facility);
      if (facility.isEnabled || this.hasLFODEnabledChildren(facility)) {
        filteredFacs.push(facility);
      }
    });
    return filteredFacs;
  }

  selectDefault(facilities: MultiFacilityModel[]) {
    facilities?.forEach((facility) => {
      const selectedFacility = this._facilityService.selectedMultiFacilities();
      const isValidLFODSup = this.isValidLFODSupportFacility(facility);
      if (selectedFacility.findIndex((f) => f === facility.facilityId) > -1 && isValidLFODSup) {
        facility.isSelected = true;
        facility.isDisabledSelectedFacility =
          this.customVideoStatus === 'copy' ||
          this.customVideoStatus === 'publish' ||
          this.customVideoStatus === 'unpublish'
            ? true
            : false;
      } else {
        facility.isSelected = false;
        facility.isDisabledSelectedFacility = false;
      }
      let isEnable = true;
      const fac = this.facilitiesConsoleEquipmentsMap.find(
        (fConsole: any) => fConsole.facilityId === facility.facilityId
      );
      if (this.customVideoStatus === 'publish') {
        if (fac.summary.userRights.customLibrary === 'F') {
          const is30FpsExist = this.frameRateList.find((val: any) => val === 30) ? true : false;
          const is24FpsExist = this.frameRateList.find((val: any) => val === 24) ? true : false;
          const isBothFrameRateExist = is30FpsExist === true && is24FpsExist === true;

          if (isBothFrameRateExist === false) {
            if (is30FpsExist) {
              if (fac.consoleEquipments) {
                const cType = fac.consoleEquipments.find((val: any) => val.consoleType === 'hal');
                if (cType !== undefined) {
                  isEnable = true;
                } else {
                  isEnable = false;
                }
              }
            }
          }
        } else {
          isEnable = false;
        }
      } else {
        if (fac.summary.userRights.customLibrary !== 'F') {
          isEnable = false;
        }
      }
      facility.isEnabled = isEnable;
      this.selectDefault(facility.children);
    });
    return facilities;
  }

  hasLFODEnabledChildren(facModel: MultiFacilityModel) {
    if (!facModel || !facModel.children) return false;
    for (const child of facModel.children) {
      if (child?.isEnabled || this.hasLFODEnabledChildren(child)) return true;
    }
    return false;
  }

  isValidLFODSupportFacility(facilityData: MultiFacilityModel) {
    return facilityData
      ? this._multiFacilityService.isMultifacilitySupported(this.currentUrl ?? this._router.url, facilityData)
      : false;
  }

  onSelectedFacilityChanged(value: any) {
    this.selectedFacilities = value;
    this.selectedCount = value.length;
  }

  onDismiss() {
    //...
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.haloTips.onDismissed();
  }

  showHaloTips() {
    if (this.commonUtil.rootScopeData.showVideoAddDescTooltip) {
      this.haloTips.add([
        {
          flag: 'showVideoAddDescTooltip',
          key: 'add-information-tip',
          message: this.commonUtil.translateText('ADD.VIDEO.INFORMATION.TOOLTIP'),
          noSkip: true,
        },
      ]);
    }
  }

  async onShowMultifacilitiesSelectorForCustomVideo(status: string) {
    this.customVideoStatus = status;
    this.selectedStrapiIdMaxIdList = JSON.parse(
      JSON.stringify(
        this.videoLibraryList.videoList
          .filter((val) => val.attributes.isSelected)
          .map((item) => ({
            strapiIdMuxid: `${item.id ? item.id : 0}-${item.attributes.muxAsset?.data?.id}`,
            muxId: `${item.attributes.muxAsset?.data?.id}`,
            videoTitle: item.attributes.title,
            product_type_filter: `${
              item.attributes.muxAsset?.data?.attributes.metadata?.data?.attributes.maxStoredFrameRate === 30
                ? 'se4,everest'
                : ''
            }`,
          }))
      )
    );

    this.refreshButtonGroup(status);
    this.selectedUploadedVideoList = this.videoLibraryList.videoList.filter(
      (val) => val.attributes.isSelected === true
    );
    await this.showMultiFacilitiesForCustomViideo(status);
  }

  async showMultiFacilitiesForCustomViideo(status: string) {
    this.frameRateList = [];
    this._loader.startProcess();
    try {
      let respMultiFacilities = await this._multiFacilityService.getMultiFacilities();
      respMultiFacilities = this.filter(JSON.parse(JSON.stringify(respMultiFacilities)));
      this.selectedUploadedVideoList.forEach((ele) => {
        if (ele.attributes.muxAsset) {
          if (ele.attributes.muxAsset.data?.attributes.metadata?.data?.attributes.maxStoredFrameRate) {
            this.frameRateList.push(
              ele.attributes.muxAsset.data?.attributes.metadata.data?.attributes.maxStoredFrameRate
            );
          }
        }
      });

      this.multiFacilities = this.selectDefault(respMultiFacilities);
      const selectedVideo = this.videoLibraryList.videoList.filter((val) => val.attributes.isSelected);
      this.selectedVideoCount = selectedVideo.map((item) => String(item.attributes.muxAsset?.data?.id)).length;
      //Below code to disable facilities that do not have custom library enable count.(Only for Publish Video)
      if (status === 'publish' || status === 'unpublish') {
        this.multiFacilitiesForPublish = await this.getMultiFacilitiesForPublishVideo(this.multiFacilities);
      }
      this.selectedCount = this.getSelectedCount(this.multiFacilities);
    } catch (error) {
      console.error('API failed.');
    }
    this._loader.endProcess();

    this._modal.add({
      dismissible: true,
      titleUppercase: true,
      modalSize: HaloModalSize.Large,
      onDismiss: this.onDismiss,
      titleTemplate: this.titleTemplateForCustomVideo,
      footerTemplate: this.actionForCustomVideo,
      bodyTemplate:
        status === 'delete'
          ? this.facilitiesTemplateForDeleteCustomVideo
          : status === 'publish'
          ? this.facilitiesTemplateForPublishCustomVideo
          : this.facilitiesTemplateForCustomVideo,
      isVideoTree: true,
    });
  }

  getFacilityIds(facilities: MultiFacilityModel[]) {
    let facilityIds: number[] = [];
    facilities?.forEach((fac) => {
      facilityIds.push(Number(fac.facilityId));
      facilityIds = facilityIds.concat(this.getFacilityIds(fac.children));
    });
    return facilityIds;
  }

  async getMultiFacilitiesForPublishVideo(facilities: any) {
    /* Start Here , Below code make facility check option to be disiabled based on the isCustomLibraryEnabledCount */
    const data = [] as any;
    const facilityIds = this.getFacilityIds(facilities);
    const tmp_1 = await this._vdoLibraryService.getEnabledOnDemandClasses(facilityIds).toPromise();
    const tmp_2 = Object.entries(tmp_1) as any;
    let se4ConsolesTypes = ['hal', 'everest', 'neo_se4', 'falco'];
    tmp_2.forEach((ele: any) => {
      if (JSON.stringify(ele) !== '{}') {
        const eqStatus = Object.values(ele[1]) as any;
        const obj = {
          facilityId: ele[0],
          isLFODEnabledCount: eqStatus.find((val: any) => val.lfodenabledCount > 0) ? true : false,
          isCustomLibraryEnabledCount: eqStatus.find((val: any) => val.customLibraryEnabledCount > 0) ? true : false,
          isSe4LFODEnabledCount: eqStatus.find(
            (val: any) => se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount > 0
          )
            ? true
            : false,
          isSe3LFODEnabledCount: eqStatus.find(
            (val: any) => !se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount > 0
          )
            ? true
            : false,
          isSe4CustomLibraryEnabledCount: eqStatus.find(
            (val: any) => se4ConsolesTypes.includes(val.consoleType) && val.customLibraryEnabledCount > 0
          )
            ? true
            : false,
          isSe3CustomLibraryEnabledCount: eqStatus.find(
            (val: any) => !se4ConsolesTypes.includes(val.consoleType) && val.customLibraryEnabledCount > 0
          )
            ? true
            : false,
        };
        data.push(obj);
      }
    });

    this.enabledEquipmentOnDemandNCustomLibrary = data;
    return this.updateIsEnabledStatus(facilities);
  }

  updateIsEnabledStatus(facilities: MultiFacilityModel[]) {
    facilities?.forEach((facility) => {
      const fac = this.facilitiesConsoleEquipmentsMap.find(
        (fConsole: any) => fConsole.facilityId === facility.facilityId
      );
      const tmp = this.enabledEquipmentOnDemandNCustomLibrary.find(
        (val: any) => val.facilityId === facility.facilityId
      );
      if (fac.summary.userRights.customLibrary === 'F') {
        if (tmp && tmp.facilityId) {
          if (tmp.isCustomLibraryEnabledCount === true) {
            const is30FpsExist = this.frameRateList.find((val: any) => val === 30) ? true : false;
            const is24FpsExist = this.frameRateList.find((val: any) => val === 24) ? true : false;
            const isBothFrameRateExist = is30FpsExist === true && is24FpsExist === true;

            if (isBothFrameRateExist === false) {
              if (is30FpsExist && !is24FpsExist) {
                if (tmp.isSe4CustomLibraryEnabledCount === true) {
                  facility.isEnabled = true;
                } else {
                  facility.isEnabled = false;
                }
              } else {
                facility.isEnabled = true;
              }
            } else {
              facility.isEnabled = true;
            }
          } else {
            facility.isEnabled = false;
          }
        }
      } else {
        facility.isEnabled = false;
      }

      this.updateIsEnabledStatus(facility.children);
    });
    return facilities;
  }

  prepareCompatibleVideo() {
    const se4CompatibleList = [];
    const se3HDN70TCompatibleList = [];
    this.selectedUploadedVideoList.forEach((val) => {
      const rate = val.attributes.muxAsset?.data?.attributes.metadata?.data?.attributes.maxStoredFrameRate;
      if (rate === 30 || rate === 24) {
        se4CompatibleList.push(val);
      }

      if (rate === 24) {
        se3HDN70TCompatibleList.push(val);
      }
    });
    const compatibleVideo = [
      {
        consoleId: '21',
        consoleType: 'everest',
        consoleThumbnail: this.cloudBasePath + '/Products/Console_EVEREST_59x49.png',
        consoleName: this.getConsoleName('everest'),
        compatibleVideoCounts: se4CompatibleList.length > 0 ? se4CompatibleList.length.toString() : '0',
        compatibleFrameRate: '24 or 30 FPS',
      },
      {
        consoleId: '22',
        consoleType: 'neo_se4',
        consoleThumbnail: this.cloudBasePath + '/Products/Console_NEO_SE4_59x49.png',
        consoleName: this.getConsoleName('neo_se4'),
        compatibleVideoCounts: se4CompatibleList.length > 0 ? se4CompatibleList.length.toString() : '0',
        compatibleFrameRate: '24 or 30 FPS',
      },
      {
        consoleId: '23',
        consoleType: 'falco',
        consoleThumbnail: this.cloudBasePath + '/Products/Console_FALCO_59x49.png',
        consoleName: this.getConsoleName('falco'),
        compatibleVideoCounts: se4CompatibleList.length > 0 ? se4CompatibleList.length.toString() : '0',
        compatibleFrameRate: '24 or 30 FPS',
      },
      {
        consoleId: '1',
        consoleType: 'hal',
        consoleThumbnail: this.cloudBasePath + '/Products/Console_HAL_59x49.png',
        consoleName: this.getConsoleName('hal'),
        compatibleVideoCounts: se4CompatibleList.length > 0 ? se4CompatibleList.length.toString() : '0',
        compatibleFrameRate: '24 or 30 FPS',
      },
      {
        consoleId: '2',
        consoleType: 'superman',
        consoleThumbnail: this.cloudBasePath + '/Products/Console_SUPERMAN_59x49.png',
        consoleName: this.getConsoleName('superman'),
        compatibleVideoCounts: se3HDN70TCompatibleList.length > 0 ? se3HDN70TCompatibleList.length.toString() : '0',
        compatibleFrameRate: '24 FPS',
      },
      {
        consoleId: '3',
        consoleType: 'mulder',
        consoleThumbnail: this.cloudBasePath + '/Products/Console_MULDER_59x49.png',
        consoleName: this.getConsoleName('mulder'),
        compatibleVideoCounts: se3HDN70TCompatibleList.length > 0 ? se3HDN70TCompatibleList.length.toString() : '0',
        compatibleFrameRate: '24 FPS',
      },
    ];

    const filteredCompatibleVideoByConsoleEquipment = [] as any;

    let compatibleConsoleList = [] as any;
    this.selectedFacilities.forEach((val) => {
      const list = this._facilityService.getFacilitityConsole(val.facilityId);
      if (list) {
        compatibleConsoleList.push(list);
      }
    });
    if (compatibleConsoleList.length > 0) {
      compatibleConsoleList = compatibleConsoleList.flat(1);
    }

    compatibleVideo.forEach((val) => {
      if (compatibleConsoleList.find((subVal: any) => subVal.consoleType === val.consoleType)) {
        filteredCompatibleVideoByConsoleEquipment.push(val);
      }
    });

    return filteredCompatibleVideoByConsoleEquipment;
  }

  onDismissCustomVideo() {
    this._modal.close();
    this.selectedCount = 0;
    this.selectedFacilities = [];
    this.displayStep = 1;
  }

  onNextCustomVideo() {
    this.displayStep = 2;
    if (this.customVideoStatus === 'publish') {
      this.viewVideoCompatibility = this.prepareCompatibleVideo();
    }
    this.refreshButtonGroup('proceedToPublish');
  }

  async onCopyCustomVideo() {
    this._modal.close();
    this._loader.startProcess();
    const facList = this.selectedFacilities.map((val: any) => val.facilityId);
    const payload = {
      facilityIds: facList.filter((id) => id !== this._facilityService.selectedFacilityId()).map(Number),
      'strapiId-MuxId': this.selectedStrapiIdMaxIdList.map((val: any) => val.strapiIdMuxid),
    };
    try {
      await this._vdoLibraryService.copyVideoLibrary(payload);
      this.selectedCount = 0;
      this.selectedFacilities = [];
      this._toast.creatToast(
        this.commonUtil.replaceValueAsHTMLOnTranslatedText('COPIED.CUSTOM.VIDEOS.SUCCESS.MSG', []),
        EToastType.SUCCESS
      );
    } catch (error) {
      this.rootScopeData.customPopupData = {
        title: 'FAILED.TO.COPY.TITLE',
        message: 'FAILED.TO.COPY',
        isWarningPopup: true,
        ctaButtonLabel: 'OK',
        isCloseIconCallsCta: true,
        hideSecondaryButton: true,
      };
      this.rootScopeData.showCustomModal = true;
    }

    try {
      await this.loadVideoLibraryList();
    } catch (error) {
      this.customLoaderIsLoading = true;
      console.error('API failed.');
    }
    this._loader.endProcess();
  }

  uniqueByKey(array: any, key: any) {
    return [...new Map(array.map((x: any) => [x[key], x])).values()];
  }

  async onDeleteCustomVideo(item: VideoInfoRaw | undefined) {
    this._modal.close();
    this._loader.startProcess();
    this.actionVideoLibraryError = [];
    this.actionVideoLibraryErrorForAllVideo = [];
    this.actionVideoLibraryErrorForFacilities = [];
    let actionVideoLibraryResp = [];

    let muxIds = [];
    let strapiMuxId: string[] = [];
    if (item) {
      muxIds = [item.attributes.muxAsset?.data?.id];
      strapiMuxId = [`${item.id ? item.id : 0}-${item.attributes.muxAsset?.data?.id}`];
    } else {
      muxIds = this.videoLibraryList.videoList
        .filter((v) => v.attributes.isSelected)
        .map((v) => v.attributes.muxAsset?.data?.id);
      strapiMuxId = this.selectedStrapiIdMaxIdList.map((val: any) => val.strapiIdMuxid);
    }

    const payload = {
      facilityIds:
        this.selectedFacilities && this.selectedFacilities.length > 0
          ? this.selectedFacilities.map((val: any) => Number(val.facilityId))
          : [Number(this.currentFacility.facilityId)],
      'strapiId-MuxId': strapiMuxId,
    };

    this._amplitudeAnalytics.logEvent({ elementName: 'Delete', action: 'Click' });
    //Delete Via Bin Icon
    if (item) {
      try {
        await this._vdoLibraryService.deleteVideoLibrary(payload);
        this._toast.creatToast(
          this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETED.CUSTOM.VIDEOS.SUCCESS.MSG', []),
          EToastType.SUCCESS
        );
        if (muxIds.length === this.videoLibraryList.totalCount % this.paginationInfo.rowsPerPage) {
          this.paginationInfo.currentPage = 1;
        }
      } catch (error) {
        this._toast.creatToast('Failed to Delete Video Library.', EToastType.ERROR);
      }
    } else {
      //Delete Via Check Options
      try {
        actionVideoLibraryResp = (await this._vdoLibraryService.deleteVideoLibrary(payload)) as any;
        const temp = actionVideoLibraryResp.filter((val: any) => val.status !== 200 && val.status !== 404);
        const temp2 = temp.map((val: any) => ({
          facilityId: val.facilityId,
          muxIdFacIdUID: val.muxIdFacIdUID,
          status: val.status,
          muxId: val.muxIdFacIdUID.split('-')[0],
        }));
        const temp3 = this.uniqueByKey(temp2, 'muxId');
        temp3.forEach((val: any) => {
          this.actionVideoLibraryErrorForAllVideo.push({
            video: this.selectedStrapiIdMaxIdList.find((subVal: any) => subVal.muxId === val.muxId).videoTitle,
            facilities: temp2
              .filter((item: any) => item.muxId === val.muxId)
              .map(
                (subItem: any) =>
                  this.selectedFacilities.find((item) => Number(item.facilityId) === Number(subItem.facilityId))
                    ?.facilityName
              ),
          });
        });

        this.actionVideoLibraryErrorForAllVideo.forEach((ele: any) => {
          ele.facilities.forEach((sub: any) => {
            this.actionVideoLibraryErrorForFacilities.push(sub);
          });
        });

        this.actionVideoLibraryError = this.actionVideoLibraryErrorForFacilities;

        this.selectedCount = 0;
        this.selectedFacilities = [];
        this.actionVideoLibraryErrorTitle = this.commonUtil.translateText('ACTION.DELETE.VIDEO.LIBRARY.ERROR.TITLE');
        this.actionVideoLibraryErrorMessage = this.commonUtil.translateText('ERROR.MSG.DELETE.FAILED');
        if (actionVideoLibraryResp.filter((val: any) => val.status !== 200 && val.status !== 404).length > 0) {
          this._modal.add({
            dismissible: true,
            titleUppercase: true,
            modalSize: HaloModalSize.Large,
            onDismiss: this.onDismiss,
            titleTemplate: this.actionErrorTitleTemplate,
            footerTemplate: this.actionErrorActionTemplate,
            bodyTemplate: this.actionErrorBodyTemplate,
            isVideoTree: false,
          });
        } else {
          this._toast.creatToast(
            this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETED.CUSTOM.VIDEOS.SUCCESS.MSG', []),
            EToastType.SUCCESS
          );
        }

        if (muxIds.length === this.videoLibraryList.totalCount % this.paginationInfo.rowsPerPage) {
          this.paginationInfo.currentPage = 1;
        }

        this.paginationInfo.currentPage =
          this.videoLibraryList.videoList.length <= this.paginationInfo.rowsPerPage
            ? 1
            : Math.floor((this.videoLibraryList.videoList.length - 1) / this.paginationInfo.rowsPerPage) + 1;
      } catch (error) {
        this._toast.creatToast('Failed to Delete Video Library.', EToastType.ERROR);
      }
    }

    try {
      await this.loadVideoLibraryList();
    } catch (error) {
      this.customLoaderIsLoading = true;
      console.error('API failed.');
    }
    this._loader.endProcess();
  }

  async onPublishCustomVideo() {
    this._modal.close();
    this._loader.startProcess();
    this.actionVideoLibraryError = [];
    this.actionVideoLibraryErrorForAllVideo = [];
    this.actionVideoLibraryErrorForFacilities = [];
    let actionVideoLibraryResp = [];
    const payload = {
      lastSelectedFacilityId: Number(this.currentFacility.facilityId),
      facilityIds: this.selectedFacilities.map((val: any) => Number(val.facilityId)),
      strapiVideoDetails: this.selectedStrapiIdMaxIdList.map((val: any) => ({
        'strapiId-MuxId': val.strapiIdMuxid,
        product_type_filter: val.product_type_filter,
      })),
    };

    try {
      actionVideoLibraryResp = (await this._vdoLibraryService.publishCustomUploadedVideos(payload).catch((error) => {
        this.rootScopeData.customPopupData = {
          title: 'ACTION.PUBLISH.VIDEO.LIBRARY.ERROR.TITLE',
          message: 'ERROR.MSG.PUBLISH.FAILED',
          isWarningPopup: true,
          ctaButtonLabel: 'OK',
          isCloseIconCallsCta: true,
          hideSecondaryButton: true,
        };
        this.rootScopeData.showCustomModal = true;
        throw error;
      })) as any;

      const temp = actionVideoLibraryResp.filter((val: any) => val.status !== 200);
      temp.forEach((ele: any) => {
        ele.strapiId = Number(ele.strapiId);
        ele.muxId = ele.muxIdFacIdUID.split('-')[0];
      });
      const temp2 = this.uniqueByKey(temp, 'muxId');
      temp2.forEach((val: any) => {
        const tA = temp.filter((item: any) => item.muxId === val.muxId);
        const facName = tA.map(
          (subItem: any) =>
            this.selectedFacilities.find((item) => Number(item.facilityId) === Number(subItem.facilityId))?.facilityName
        );

        this.actionVideoLibraryErrorForAllVideo.push({
          video: val.videoTitle,
          facilities: facName,
        });
      });

      this.actionVideoLibraryError = this.actionVideoLibraryErrorForAllVideo;
      this.selectedCount = 0;
      this.selectedFacilities = [];
      //Reset Button Group.
      this.onBackCustomVideo();
      this.actionVideoLibraryErrorTitle = this.commonUtil.translateText('ACTION.PUBLISH.VIDEO.LIBRARY.ERROR.TITLE');
      this.actionVideoLibraryErrorMessage = this.commonUtil.translateText('ERROR.MSG.PUBLISH.FAILED');
      if (actionVideoLibraryResp.filter((val: any) => val.status !== 200).length > 0) {
        this._modal.add({
          dismissible: true,
          titleUppercase: true,
          modalSize: HaloModalSize.Large,
          onDismiss: this.onDismiss,
          titleTemplate: this.actionErrorTitleTemplate,
          footerTemplate: this.actionErrorActionTemplate,
          bodyTemplate: this.actionErrorBodyTemplateForPublishCustomVideo,
          isVideoTree: false,
        });
      } else {
        this._toast.creatToast(
          this.commonUtil.replaceValueAsHTMLOnTranslatedText('PUBLISHED.CUSTOM.VIDEOS.SUCCESS.MSG', []),
          EToastType.SUCCESS
        );
      }
    } catch (error) {
      console.log(error);
      this.onDismissCustomVideo();
    }

    try {
      await this.loadVideoLibraryList();
    } catch (error) {
      this.customLoaderIsLoading = true;
      console.error('API failed.');
    }
    this._loader.endProcess();
  }

  async onUnpublishCustomVideo() {
    this._modal.close();
    this._loader.startProcess();
    let actionVideoLibraryResp = [];
    let payload;
    payload = {
      facilityIds: this.selectedFacilities.map((val: any) => Number(val.facilityId)),
      'strapiId-MuxId': this.selectedStrapiIdMaxIdList.map((val: any) => val.strapiIdMuxid),
    };

    try {
      actionVideoLibraryResp = (await this._vdoLibraryService.unpublishCustomUploadedVideos(payload).catch((error) => {
        throw error;
      })) as any;
      this.selectedCount = 0;
      this.selectedFacilities = [];
      //Reset Button Group.
      this.onBackCustomVideo();
      if (actionVideoLibraryResp.filter((val: any) => val.status === 200).length > 0) {
        this._toast.creatToast(
          this.commonUtil.replaceValueAsHTMLOnTranslatedText('UNPUBLISHED.CUSTOM.VIDEOS.SUCCESS.MSG', []),
          EToastType.SUCCESS
        );
      }
    } catch (error) {
      console.log(error);
      this.onDismissCustomVideo();
    }

    try {
      await this.loadVideoLibraryList();
    } catch (error) {
      this.customLoaderIsLoading = true;
      console.error('API failed.');
    }
    this._loader.endProcess();
  }

  onBackCustomVideo() {
    this.displayStep = 1;
    this.refreshButtonGroup('publish');
  }

  closeDisabledModal() {
    this.showUploadDisable = false;
  }

  onUploadVideo() {
    if(this.videoLibraryList?.countExceeded || this.videoLibraryList?.minutesExceeded) {
      this.showUploadDisable = true;
    } else {
      this.commonUtil.navigatePage(['/videoLibrary/upload']);
    }
  }

  refreshButtonGroup(status: string) {
    if (status === 'delete') {
      this.buttonGroup = ['cancel', 'delete'];
    } else if (status === 'copy') {
      this.buttonGroup = ['cancel', 'copy'];
    } else if (status === 'publish') {
      this.buttonGroup = ['cancel', 'next'];
    } else if (status === 'unpublish') {
      this.buttonGroup = ['cancel', 'unpublish'];
    } else {
      this.buttonGroup = ['cancel', 'back', 'publish'];
    }
  }
  async onSortingClick(columnName: string) {
    if (this.sortingInfo.columnName === columnName) {
      this.sortingInfo.isAscOrder = !this.sortingInfo.isAscOrder;
    } else {
      this.sortingInfo.columnName = columnName;
      this.sortingInfo.isAscOrder = true;
    }
    this.customLoaderIsLoading = true;
    try {
      await this.loadVideoLibraryList();
      this.customLoaderIsLoading = false;
    } catch (error) {
      console.error('API failed.');
    }
  }

  async paginationChanged(event: any) {
    const previousPaginationInfo = this.paginationInfo;
    this.paginationInfo = event;
    if (
      previousPaginationInfo.currentPage !== this.paginationInfo.currentPage ||
      previousPaginationInfo.rowsPerPage !== this.paginationInfo.rowsPerPage
    ) {
      this.customLoaderIsLoading = true;
      try {
        await this.loadVideoLibraryList();
        this.customLoaderIsLoading = false;
      } catch (error) {
        console.error('API failed.');
      }
    }
  }

  async onDeleteVideo(item: VideoInfoRaw) {
    if (!item) return;
    if (item.attributes.validationErrors && item.attributes.validationErrors.length > 0) {
      this._vdoLibraryService.removeVideoFromList(item);
    } else {
      await this._vdoLibraryService.dismissUploadVideo(item);
      await this.onDeleteCustomVideo(item);
    }
  }

  private setActionBar(show: boolean) {
    this.showActionBar = show;
    this.commonUtil.rootScopeData.isPageHasUnsavedChanges = show;
  }

  private getConsoleName(consoleType: string) {
    return this.rootScopeData?.consoleRights?.get(consoleType)?.consoleName;
  }
}
